import { Typography } from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react';
// import './styles.css';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Box, Card, CardContent, Grid, Stack } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TrialHeader from '../../../components/Accounts/Account/trialheader';
import Loader from '../../../components/Accounts/Loader';
import Report from '../../../components/Accounts/Reports/report';
import { calculateDebitCredit, parseIntFunction } from '../../../utils/Level/utils';
import { getAllVoucherDataByDate } from '../../../utils/endPoints';
import { useAppSelector } from '../../../utils/hooks';

function TrialBalance() {
  const isMediumScreen = useMediaQuery('(min-width: 960px)');
  const level_3 = useAppSelector(state => state.accountLevels.level3);
  const [trialData, setTrialData] = useState({});
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  async function getTrialData(startDate) {

    try{
      setLoading(true)
    let data = [];
    let refPromises = [];
    let level1Array = {};
    level_3.forEach(async code => {
      let result = getAllVoucherDataByDate(
        code.fullcode,
        moment(startDate).format('DD-MM-YYYY'), //startDate.toString().split('/').join('-'),
      ).then(vouchers => {
        console.log('Vouchers: ', vouchers);
        let res = calculateDebitCredit(vouchers);
        let openingBalance = code.amount;

        openingBalance = parseIntFunction(openingBalance);
        if (code.transactionType === 'Credit') {
          openingBalance = -openingBalance;
        }
        if (level1Array[code.l1code]) {
          level1Array[code.l1code].push({
            ...code,
            l1desc: code.Discription,
            amount: openingBalance + res[0] - res[1],
          });
        } else {
          level1Array[code.l1code] = {};
          level1Array[code.l1code] = [];
          level1Array[code.l1code].push({
            ...code,
            l1desc: code.Discription,
            amount: openingBalance + res[0] - res[1],
          });
        }
      });
      refPromises.push(result);
    });
    await Promise.all(refPromises);
    console.log(level1Array);

    openReport(startDate, Object.values(level1Array));
    setLoading(false)
  }
  catch{
    setLoading(false)
  }
  }
  function openReport(startDate, finalArray, level1Array) {
    console.log(finalArray);
    var trialObj = {
      id: '617fb229f661460020535df3',
      invoice_no: '202010-93',
      invoice: finalArray,
      level1Array,
      titleData: {
        heading: 'National Bake Factory',
        title: 'Trial Balance',
        subTitle: 'Upto ' + new Date(startDate).toLocaleString().split(',')[0],
        leftTitle: '',
        leftSubTitle: '',
        rightTitle: '',
        rightSubTitle: '',
      },
      docType: 'Trial',
      from: '',
      to: '',
      codeDetails: {
        codeLevel2: '',
        descLevel2: '',
        codeLevel3: '',
        descLevel3: '',
      },
      totalDebit: '',
      totalCredit: '',
      balance: '',
      openingBalance: '',
    };

    setTrialData(trialObj);
    handleOpen();
  }

  const [loading, setLoading] = useState(false);

  return (
    <div>
      <Loader loading={loading} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop:'1rem',
          justifyContent: 'center',
          // backgroundColor: '#5CDB95',
        }}
      >
        <ToastContainer
          position="bottom-center"
          autoClose={2000}
          hideProgressBar={true}
          closeOnClick={true}
          progress={undefined}
        />

        <Typography variant="h5" component="h2" gutterBottom>
            Trial_Balance
        </Typography>
                    <TrialHeader
                      searchCallback={startDate => {
                        getTrialData(startDate);
                      }}
                    ></TrialHeader>
                    <Report
                      open={open}
                      handleClose={handleClose}
                      data={trialData}
                    />
      </div>
    </div>
  );
}

export default TrialBalance;
